import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { concatMap, of, tap, filter, from } from 'rxjs'
import { handleMessages } from '../modules/client/utilities'

export default {
  state: () => ({
    jackpotCounters: [],
    selectedJackpotCounter: null
  }),
  actions: {
    getJackpotCounters(context, { config = {} } = { config: {} }) {
      const { commit } = context
      return from(
        this.$axios.$get(
          `/webapi/index/getAllGameJackpot`,
          getAxiosConfig(context, config)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(({ data }) => of(data || [])),
          concatMap(data =>
            of(
              Object.keys(data).map(platform => ({
                platform,
                counter: data[platform]
              }))
            )
          ),
          tap(jackpotCounters => commit('JACKPOT_COUNTERS', jackpotCounters)),
          concatMap(jackpotCounters =>
            of(
              jackpotCounters && jackpotCounters.length > 0
                ? jackpotCounters[0]
                : null
            )
          ),
          tap(jackpotCounter =>
            commit('SELECTED_JACKPOT_COUNTER', jackpotCounter)
          )
        )
        .toPromise()
    },
    selectJackpotCounter({ commit }, payload) {
      commit('SELECTED_JACKPOT_COUNTER', payload)
    }
  },
  mutations: {
    JACKPOT_COUNTERS(state, payload) {
      state.jackpotCounters = payload
    },
    SELECTED_JACKPOT_COUNTER(state, payload) {
      state.selectedJackpotCounter = payload
    }
  },
  getters: {
    jackpotCounters: state => state.jackpotCounters,
    selectedJackpotCounter: state => state.selectedJackpotCounter
  }
}
